const search_selector = 'script[type="text/dlb-ls-search+json"]';
const product_selector = 'script[type="text/dlb-ls-product+json"]';
const localstorage_key = "dlb-searches";

document.addEventListener("DOMContentLoaded", () => {
  const is_search = document.querySelectorAll(search_selector).length > 0;
  const is_product = document.querySelectorAll(product_selector).length > 0;

  if (is_search === true) {
    handle_search();
  } else if (is_product === true) {
    handle_product(
      document.querySelector(product_selector).textContent || ""
    ).catch((error) => console.log("Could not find product", error));
  }
});

function handle_search() {
  const params = new URLSearchParams(window.location.search);

  const search_term = params.get("q") || "";
  const term_key = btoa(search_term);

  wait_for_snize()
    .then(async () => {
      const results = await fetch_all_entries(search_term, 1);

      const existing_searches = JSON.parse(
        localStorage.getItem(localstorage_key) || "{}"
      );
      const new_searches = {
        ...existing_searches,
        [term_key]: results,
      };

      localStorage.setItem(localstorage_key, JSON.stringify(new_searches));

      replace_all_product_urls(term_key, search_term);
      install_mutation_observer(term_key, search_term);
    })
    .catch((error) => console.log("Could not find snize", error));
}

/**
 *
 *
 * @param {string} current_product_id
 * @return {*}
 */
async function handle_product(current_product_id) {
  const parsed_params = new URLSearchParams(window.location.search);
  const latest_search_key = parsed_params.get("lsk");
  const encoded_search_term = encodeURIComponent(latest_search_key);
  const page_number = parseInt(parsed_params.get("sp") || "1");

  if (latest_search_key === null) {
    return;
  }

  const search_data = JSON.parse(
    localStorage.getItem(localstorage_key) || "{}"
  );

  if (search_data[latest_search_key] === undefined) {
    return;
  }

  const entries = search_data[latest_search_key];
  const entry_index = entries.findIndex(
    (entry) =>
      entry.product_id.trim() ===
      current_product_id.trim().replace("\n", "").replace("\\n", "")
  );

  if (entry_index === -1) {
    return;
  }

  if (entry_index < 6 && page_number > 1) {
    // Fetch the previous page
    let response = await fetch(
      `http://searchserverapi.com/getresults?api_key=4G6s9N6h2F&q=${encoded_search_term}&sortBy=relevance&sortOrder=desc&startIndex=${
        (page_number - 1) * 24
      }&page=${page_number}&maxResults=24&items=true&pages=true&categories=true&suggestions=true&queryCorrection=true&suggestionsMaxResults=3&pageStartIndex=0&pagesMaxResults=3&categoryStartIndex=0&categoriesMaxResults=0&facets=true&facetsShowUnavailableOptions=false&ResultsTitleStrings=1&ResultsDescriptionStrings=3&output=jsonp`
    );

    let response_body = await response.json();
    let new_entries = response_body.items.concat(entries.slice(-11));

    let new_search_data = { ...search_data, [latest_search_key]: new_entries };
    localStorage.setItem(localstorage_key, JSON.stringify(new_search_data));
  } else if (entry_index < entries.length - 13 && page_number > 1) {
    // Fetch the next page
    let response = await fetch(
      `http://searchserverapi.com/getresults?api_key=4G6s9N6h2F&q=${encoded_search_term}&sortBy=relevance&sortOrder=desc&startIndex=${
        (page_number - 1) * 24
      }&page=${page_number}&maxResults=24&items=true&pages=true&categories=true&suggestions=true&queryCorrection=true&suggestionsMaxResults=3&pageStartIndex=0&pagesMaxResults=3&categoryStartIndex=0&categoriesMaxResults=0&facets=true&facetsShowUnavailableOptions=false&ResultsTitleStrings=1&ResultsDescriptionStrings=3&output=jsonp`
    );

    let response_body = await response.json();
    let new_entries = entries.slice(11).concat(response_body.items);
    let new_search_data = { ...search_data, [latest_search_key]: new_entries };
    localStorage.setItem(localstorage_key, JSON.stringify(new_search_data));
  }

  const previous_item = entry_index === 0 ? null : entries[entry_index - 1];
  const next_item =
    entry_index === entries.length - 1 ? null : entries[entry_index + 1];

  const previous_arrows = document.querySelectorAll(
    ".product-navigation-arrow.arrow--previous"
  );
  const next_arrows = document.querySelectorAll(
    ".product-navigation-arrow.arrow--next"
  );

  if (previous_item !== null) {
    previous_arrows.forEach((arrow) => {
      arrow.href = `${window.location.origin}${previous_item.link}?lsk=${latest_search_key}&sp=${page_number}`;
      arrow.title = previous_item.title;
      arrow.classList.add("is--visible");
    });
  }

  if (next_item !== null) {
    next_arrows.forEach((arrow) => {
      arrow.href = `${window.location.origin}${next_item.link}?lsk=${latest_search_key}&sp=${page_number}`;
      arrow.title = next_item.title;
      arrow.classList.add("is--visible");
    });
  }
}

function wait_for_snize() {
  let current_try = 0;
  let max_tries = 100;
  let wait_interval = 1000;

  return new Promise((resolve, reject) => {
    const handle_countdown = () => {
      if (current_try >= max_tries) {
        return reject();
      }

      const element = document.querySelector(
        ".snize-search-results-header .snize-no-products-found-link"
      );

      if (element !== null) {
        return resolve();
      } else {
        current_try++;
        setTimeout(handle_countdown, wait_interval);
      }
    };

    handle_countdown();
  });
}

async function fetch_all_entries(
  search_term,
  page_number,
  current_entries = []
) {
  const encoded_search_term = encodeURIComponent(search_term);
  let response = await fetch(
    `http://searchserverapi.com/getresults?api_key=4G6s9N6h2F&q=${encoded_search_term}&sortBy=relevance&sortOrder=desc&startIndex=${
      (page_number - 1) * 24
    }&page=${page_number}&maxResults=24&items=true&pages=true&categories=true&suggestions=true&queryCorrection=true&suggestionsMaxResults=3&pageStartIndex=0&pagesMaxResults=3&categoryStartIndex=0&categoriesMaxResults=0&facets=true&facetsShowUnavailableOptions=false&ResultsTitleStrings=1&ResultsDescriptionStrings=3&output=jsonp`
  );

  let response_body = await response.json();
  let entries = current_entries.concat(response_body.items);

  if (page_number > 1) {
    const response = await fetch(
      `http://searchserverapi.com/getresults?api_key=4G6s9N6h2F&q=${encoded_search_term}&sortBy=relevance&sortOrder=desc&startIndex=${
        (page_number - 2) * 24
      }&page=${page_number}&maxResults=24&items=true&pages=true&categories=true&suggestions=true&queryCorrection=true&suggestionsMaxResults=3&pageStartIndex=0&pagesMaxResults=3&categoryStartIndex=0&categoriesMaxResults=0&facets=true&facetsShowUnavailableOptions=false&ResultsTitleStrings=1&ResultsDescriptionStrings=3&output=jsonp`
    );

    const response_body = await response.json();

    entries = response_body.items.concat(entries);
  }

  response = await fetch(
    `http://searchserverapi.com/getresults?api_key=4G6s9N6h2F&q=${encoded_search_term}&sortBy=relevance&sortOrder=desc&startIndex=${
      page_number * 24
    }&page=${page_number}&maxResults=24&items=true&pages=true&categories=true&suggestions=true&queryCorrection=true&suggestionsMaxResults=3&pageStartIndex=0&pagesMaxResults=3&categoryStartIndex=0&categoriesMaxResults=0&facets=true&facetsShowUnavailableOptions=false&ResultsTitleStrings=1&ResultsDescriptionStrings=3&output=jsonp`
  );

  response_body = await response.json();

  entries = entries.concat(response_body.items);

  return entries;
}

function install_mutation_observer(latest_search_key, search_term) {
  const mutation_observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        replace_all_product_urls(latest_search_key, search_term);
      }
    });
  });

  mutation_observer.observe(
    document.querySelector(".snize-search-results-content"),
    {
      childList: true,
    }
  );
}

function replace_all_product_urls(latest_search_key, search_term) {
  const current_page =
    document.querySelector(".snize-pagination a.active")?.innerHTML ?? "1";

  fetch_all_entries(search_term, parseInt(current_page)).then((new_data) => {
    const existing_searches = JSON.parse(
      localStorage.getItem(localstorage_key) || "{}"
    );
    const new_searches = {
      ...existing_searches,
      [latest_search_key]: new_data,
    };

    localStorage.setItem(localstorage_key, JSON.stringify(new_searches));
  });

  document
    .querySelectorAll(".snize-product a.snize-view-link")
    .forEach((element) => {
      const parsed_url = new URL(element.href);

      if (parsed_url.searchParams.has("lsk")) {
        return;
      }

      parsed_url.searchParams.set("lsk", latest_search_key);
      parsed_url.searchParams.set("sp", current_page);

      element.href = parsed_url;
    });
}
